import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import useGiphyObserver from 'components/Giphy/useGiphyObserver';
import { chatFontSettings } from 'utils/helpers';

import Gif from './components/Gif';
import styles from './ChatMessageTypes.css';


function SelfMessage({ msg, isDesktop, chatSettings, isBroadcasterChat }) {
  const [giphyObserver, isIntersecting] = useGiphyObserver();

  const messageClasses = classNames({
    [styles.yourMsgWrap]: true,
    [styles.broadcasterMargin]: isBroadcasterChat,
    [styles.gifBackgroundSelf]: msg.isGif,
  });

  return (
    <div
      ref={giphyObserver}
      className={messageClasses}
      style={chatFontSettings(isDesktop, chatSettings)}
    >
      {isDesktop && !isBroadcasterChat && (
        <div className={styles.pointerMe}> Me </div>
      )}
      <Gif
        alt={msg.message}
        isIntersecting={isIntersecting}
        msg={msg}
      />
    </div>
  );
}

SelfMessage.propTypes = {
  chatSettings: PropTypes.object,
  isBroadcasterChat: PropTypes.bool,
  isDesktop: PropTypes.bool,
  msg: PropTypes.object,
};

SelfMessage.defaultProps = {
  chatSettings: {},
  isBroadcasterChat: false,
  isDesktop: false,
  msg: {},
};


export default SelfMessage;
